import {
  Component,
  DestroyRef,
  inject,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/auth';
import { ProfileDetails } from '@app/profile/profile.types';

@Component({
  selector: 'app-setting-menu',
  templateUrl: './setting-menu.component.html',
  styleUrls: ['./setting-menu.component.scss'],
  standalone: false,
})
export class SettingMenuComponent {
  @Input('profileInfo') profileInfo: ProfileDetails;
  @Input('locale') locale: string;
  @Output() localeChange: EventEmitter<string> = new EventEmitter();

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  private destroyRef = inject(DestroyRef);

  profile() {
    this.router.navigateByUrl('/profile');
  }

  logout() {
    this.authenticationService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.router.navigate(['/login'], { replaceUrl: true }));
  }

  onLocaleChange() {
    this.locale = this.locale == 'ar' ? 'en-US' : 'ar';
    this.localeChange.emit(this.locale);
  }
}
